// extracted by mini-css-extract-plugin
export default {"root":"MinimalNoTopbar_root__RgUW+","content":"MinimalNoTopbar_content__LQR-+","header":"MinimalNoTopbar_header__Zv0Ae"};